import React from 'react'
import Index from '../views/dashboard/index'

import Default from '../layouts/dashboard/default';
import UserList from '../views/dashboard/UserList';

import PrivateRoute from '../views/dashboard/auth/PrivateRoute';
import SignIn from '../views/dashboard/auth/sign-in';
import { Navigate } from 'react-router-dom';
import ReportedUsers from '../views/dashboard/ReportedUsers';
import ReportList from '../views/dashboard/ReportList';
import UnderVerification from '../views/dashboard/UnderVerification';
import ViewUser from '../views/dashboard/ViewUser';
import CreateAdmin from '../views/dashboard/auth/CreateAdmin';
import AdminList from '../views/dashboard/auth/AdminList';
import AdminProfile from '../views/dashboard/auth/AdminProfile';
import EditAdmin from '../views/dashboard/EditAdmin';
import SuspendedList from '../views/dashboard/SuspendedList';
import PlanList from '../views/dashboard/PlanList';
import AddData from '../views/dashboard/AddData';
import ViewData from '../views/dashboard/ViewData';
import AddCountry from '../views/dashboard/AddCountry';
import ViewCoutnry from '../views/dashboard/ViewCoutnry';
import AddSubscription from '../views/dashboard/AddSubscription';
import SubscribedUser from '../views/dashboard/SubscribedUser';
import Faq from '../views/dashboard/Faq';
import DeletedAccounts from '../views/dashboard/DeletedAccounts';
import ViewEducationDetails from '../views/dashboard/ViewEducationDetails';
import AddEducationDetails from '../views/dashboard/AddEducationDetails';
import ViewHobbies from '../views/dashboard/ViewHobbies';
import AddAudio from '../views/dashboard/V.1.1/AddAudio';
import ViewAudio from '../views/dashboard/V.1.1/ViewAudio';
import AddTemplate from '../views/dashboard/V.1.1/AddTemplate';
import ViewTemplate from '../views/dashboard/V.1.1/ViewTemplate';
import EditAudio from '../views/dashboard/V.1.1/EditAudio';
import Reels from '../views/dashboard/V.1.1/Reels';
import VerifyReels from '../views/dashboard/V.1.1/VerifyReels';

export const DefaultRouter = [
    {
        path: '/',
        element: <PrivateRoute element={<Default />} />,
        children: [
            {
                path: '/dashboard',
                element: <PrivateRoute element={<Index />} />
            },
            {
                path:"/userList",
                element:<PrivateRoute element={<UserList />} />
            },
            {
                path:"/reportedUsers",
                element:<PrivateRoute element={< ReportedUsers/>} />
            },
            {
                path:"/reportList/:id",
                element:<PrivateRoute element={<ReportList />} />
            },
            {
                path:"/suspendedList",
                element:<PrivateRoute element={<SuspendedList />} requiredPermission={["suspend"]} />
            },
            {
                path:"/underVerification",
                element:<PrivateRoute element={<UnderVerification />} requiredPermission={["verification"]} />
            },
            {
                path:"/viewUser/:id",
                element:<PrivateRoute element={<ViewUser />} requiredPermission={["verification"]} />
            },
            {
                path:"/createAdmin",
                element:<PrivateRoute element={<CreateAdmin />} requiredPermission={["create"]} />
            },
            {
                path:"/viewAdmin",
                element:<PrivateRoute element={<AdminProfile />} />
            },
            {
                path:"/adminList",
                element:<PrivateRoute element={<AdminList />} />
            },
            {
                path:"/editAdmin/:id",
                element:<PrivateRoute element={<EditAdmin />} requiredPermission={["edit"]} />
            },
            {
                path:"/viewPlans",
                element:<PrivateRoute element={<PlanList />} requiredPermission={["subscription"]} />
            },
            {
                path:"/addSubscription",
                element:<PrivateRoute element={<AddSubscription />} requiredPermission={["subscription"]} />
            },
            {
                path:"/subscribers",
                element:<PrivateRoute element={<SubscribedUser />} requiredPermission={["subscription"]} />
            },
            {
                path:"/addData",
                element:<PrivateRoute element={<AddData />} requiredPermission={["create"]} />
            },
            {
                path:"/viewData",
                element:<PrivateRoute element={<ViewData />} requiredPermission={["create","view","edit","delete"]}/>
            },
            {
                path:"/addCountry",
                element:<PrivateRoute element={<AddCountry />} requiredPermission={["create"]} />
            },
            {
                path:"/viewCountry",
                element:<PrivateRoute element={<ViewCoutnry />} requiredPermission={["view","edit","delete"]} />
            },
            {
                path:"/faq",
                element:<PrivateRoute element={<Faq />} requiredPermission={["create","view","edit","delete"]} />
            },
            {
                path:"/deletedAccounts",
                element:<PrivateRoute element={<DeletedAccounts />} />
            },
            {
                path:"/viewEducation",
                element:<PrivateRoute element={<ViewEducationDetails />} requiredPermission={['edit','delete']} />
            },
            {
                path:"/addEducation",
                element:<PrivateRoute element={<AddEducationDetails />} requiredPermission={['create']} />
            },
            {
                path:"/hobby",
                element:<PrivateRoute element={<ViewHobbies />} requiredPermission={["create","view","edit","delete"]} />
            },
            {
                path:"/add-audio",
                element:<PrivateRoute element={<AddAudio />} requiredPermission={["create","view","edit","delete"]} />
            },
            {
                path:"/view-audio",
                element:<PrivateRoute element={<ViewAudio />} requiredPermission={["create"]} />
            },
            {
                path:"/edit-audio",
                element:<PrivateRoute element={<EditAudio />} requiredPermission={["edit"]} />
            },
            {
                path:"/add-template",
                element:<PrivateRoute element={<AddTemplate />} requiredPermission={["create"]} />
            },
            {
                path:"/view-template",
                element:<PrivateRoute element={<ViewTemplate />} requiredPermission={["create","view","edit","delete"]} />
            },
            {
                path:"/reels",
                element:<PrivateRoute element={<Reels />} requiredPermission={["verification","create","view","edit","delete"]} />
            },
            {
                path:"/verify-reels",
                element:<PrivateRoute element={<VerifyReels />} uiredPermission={["verification"]} />
            }
        ]
    },
    {
        path:'/login',
        element:<SignIn />
    },
    {
        path:'/*',
        element:<Navigate to="/login" replace />
    }
]
